import Splide from '@splidejs/splide';

export const defaultTranslations: Record<string, string> = {
  prev: 'Föregående sida',
  next: 'Nästa sida',
  first: 'Gå till första bilden',
  last: 'Gå till sista bilden',
  slideX: 'Gå till bild %s',
  pageX: 'Gå till sida %s',
  play: 'Starta automatisk uppspelning',
  pause: 'Pausa automatisk uppspelning',
  carousel: 'karusell',
  select: 'Välj en sida att visa',
  slide: 'bild',
  slideLabel: '%s av %s'
};

export const initSlideProductList = (list: Element) => {
  if (list.classList.contains('is-initialized')) {
    return;
  }

  list.classList.add('splide');
  let perView: number = parseInt(list.attributes['data-perview']?.value, 10);
  const productCardType: string = list.attributes['data-product-card-type']?.value;
  let paddingRight = 0.22;

  if (!perView) {
    perView = 5;
  }

  if (productCardType.toUpperCase() === 'PRODUCTCARDLIST') {
    paddingRight = 0.10;
  }

  new Splide(list as HTMLElement, {
    type: 'loop',
    perPage: perView,
    speed: 500,
    dragMinThreshold: 20,
    flickMaxPages: 1,
    flickPower: 100,
    snap: false,
    arrows: true,
    breakpoints: {
      1100: {
        perPage: 2,
        arrows: true,
        pagination: false
      },
      768: {
        perPage: 1,
        arrows: false,
        padding: {
          left: 0,
          right: list.clientWidth * paddingRight
        }
      }
    },
    i18n: {
      ...defaultTranslations,
      prev: 'Föregående produkt',
      next: 'Nästa produkt',
      first: 'Gå till första produkten',
      last: 'Gå till sista produkten',
      slideX: 'Gå till produkt %s',
      carousel: 'produktkarusell',
      select: 'Välj en produkt att visa',
      slide: 'produkt',
      slideLabel: 'Produkt %s av %s'
    }
  }).mount();
};
